<template>
	<div class="main">
		<div class="news-title">
			<i class="iconfont iconanchor-full"></i>
			<div style="margin: 0 20px;">
				中国人民解放军海军博物馆志愿者服务章程
			</div>
			<i class="iconfont iconanchor-full"></i>
		</div>
		<p class="p-center p-font">
			第一章 总则
		</p>
		<p class="p-font p-left">
			第一条为加强与广大观众的联系、交流，扩大博物馆的文化普及程度，提升义务咨询和讲解服务的力度，中国人民解放军海军博物馆志愿者吸收热爱博物馆事业，具有奉献精神，自愿利用个人的时间，无偿为博物馆服务的人士为“中国人民解放军海军博物馆志愿者”。
		</p>
		<p class="p-font p-left">
			第二条 志愿者的身份由中国人民解放军海军博物馆志愿者认定。志愿者须遵守军博的各项规章制度，自觉服从中国人民解放军海军博物馆的管理。
		</p>
		<p class="p-font p-left">
			第三条 志愿者以志愿服务为宗旨，以传播军事历史、军事文化、军事科技、军事艺术知识为目标，倡导社会爱心，发扬团结互助，以服务社会大众为己任。
		</p>
		<p class="p-center p-font">
			第二章 组织形式
		</p>
		<p class="p-font p-left">
			第四条 中国人民解放军海军博物馆志愿者组织的管理架构
		</p>
		<p class="p-font p-left">
			第五条 展陈管理教育部负责每年中国人民解放军海军博物馆志愿者的招募、培训考核、日常管理、监察等工作，具体工作由宣传教育室承担。
		</p>
		<p class="p-font p-left">
			第六条 每年召开一次工作会议，全面总结上一年度工作和部署下年度工作。
		</p>
		<p class="p-center p-font">
			第三章 经费管理
		</p>
		<p class="p-font p-left">
			第七条 志愿者相关工作的费用每年从中国人民解放军海军博物馆志专项经费中列支。
		</p>
		<p class="p-font p-left">
			第八条 志愿者工作活动经费的申请及使用必须履行中国人民解放军海军博物馆志财务管理办法的相应程序。
		</p>
		<p class="p-center p-font">
			第四章 招募条件与程序
		</p>
		<p class="p-font p-left">
			第九条 身心健康、口齿清楚，具有大专以上文化程度，年龄在18至65周岁之间，愿意无偿服务的社会人士。
		</p>
		<p class="p-font p-left">
			第十条 中国人民解放军海军博物馆志根据工作需要，直接招募或通过有关单位、院校、社会团体招募志愿者；按照自愿网上报名、面试甄选、政审审核、培训考核、录取签约的程序进行招募。
		</p>
		<p class="p-font p-left">
			第十一条 通过培训考核并正式上岗，志愿服务满1年且达标的志愿者，由中国人民解放军海军博物馆有关部门或领导审核批准后，方可成为中国人民解放军海军博物馆注册登记的志愿者。
		</p>
		<p class="p-center p-font">
			第五章 工作内容
		</p>
		<p class="p-font p-left">
			第十二条 志愿者主要服务岗位分为：观众咨询服务、展厅引导服务、展览讲解服务及辅助博物馆开展各项社会教育服务活动等。
		</p>
		<p class="p-font p-left">
			第十三条 根据不同服务岗位，中国人民解放军海军博物馆志愿者者采取预约时间或固定时间的方式来馆志愿服务。
		</p>
		<p class="p-font p-left">
			第十四条 中国人民解放军海军博物馆志愿者需保证全年服务时长，具体服务时长按照《中国人民解放军海军博物馆志愿者工作细则》执行。
		</p>
		<p class="p-center p-font">
			第六章 权利与义务
		</p>
		<p class="p-font p-left">
			第十五条 志愿者根据实际工作时间段，可免费享有工作午餐；享有折扣购买中国人民解放军海军博物馆文化产品的权利。
		</p>
		<p class="p-font p-left">
			第十六条 志愿者享有馆内外交流学习、借阅业务书籍、参加中国人民解放军海军博物馆讲座等权利；志愿服务满1年的优秀中国人民解放军海军博物馆志愿者将获赠图书和中国人民解放军海军博物馆纪念品等相应奖励。
		</p>
		<p class="p-font p-left">
			第十七条 履行《中国人民解放军海军博物馆志愿者承诺》，完成志愿服务任务，传播志愿服务理念。
		</p>
		<p class="p-font p-left">
			第十八条 遵守国家法律法规，遵守军中国人民解放军海军博物馆相关规定及保密守则，遵守本章程及工作细则；按时参加中国人民解放军海军博物馆组织的相关业务培训，服从中国人民解放军海军博物馆工作管理安排；不能正常开展志愿者工作或违反规定的志愿者，中国人民解放军海军博物馆有权将其劝退军博志愿者团队，并收回相关证件。
		</p>
		<p class="p-center p-font">
			第七章 附则
		</p>
		<p class="p-font p-left">
			第十九条 中国人民解放军海军博物馆对本章程拥有最终解释权。
		</p>
		<p class="p-font p-left">
			第二十条 本章程自中国人民解放军海军博物馆批准之日起生效。
		</p>
		<div class="back">
			<div class="back-button" @click="$router.back(-1)">
				返回
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: '',
		data () {
			return {

			}
		},
		mounted() {
			let that = this
			that.$store.state.showTopImage = true
			that.$store.state.topImage = '../../static/top_banner_4.png'
		},
		methods: {

		}
	}
</script>

<style lang="less" scoped>
	.main {
		width: 80%;
		margin: 18px 10% 80px;
		.news-title {
			display: flex;
			height: 80px;
			line-height: 80px;
			font-size: 20px;
			color: #922627;
			text-align: center;
			justify-content: center;
			border-bottom: 3px solid #EDD68E;
			margin-bottom: 10px;
			i {
				font-size: 17px;
				color: #F8C822;
			}
		}
		.p-font {
			color: #264EA7;
			font-size: 18px;
			margin-top: 15px;
		}
		.p-center {
			text-align: center;
		}
		.p-left {
			text-align: left;
			text-indent: 2em;
		}
		.back {
			position: relative;
			margin: 30px 0;
			height: 20px;
			.back-button {
				position: absolute;
				width: 75px;
				height: 20px;
				line-height: 20px;
				font-size: 9px;
				border: 1px solid #0E40DF;
				color: #0E40DF;
				text-align: center;
				right: 28px;
				cursor: pointer;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/teaching_activities/zyzzc_zc.vue